import React from 'react';

import AmericanExpress from './AmericanExpress';
import ApplePay from './ApplePay';
import ArrowLeft from './ArrowLeft';
import BankPayment from './BankPayment';
import Bill from './Bill';
import BillClock from './BillClock';
import BillOutline from './BillOutline';
import BoxClosed from './BoxClosed';
import Calendar from './Calendar';
import CalendarBill from './CalendarBill';
import CardPayment from './CardPayment';
import CaretLeft from './CaretLeft';
import Cash from './Cash';
import Check from './Check';
import ChinaUnionPay from './ChinaUnionPay';
import CircleI from './CircleI';
import Discover from './Discover';
import Dismiss from './Dismiss';
import DinersClub from './DinersClub';
import IconCircleExclamationRed from './IconCircleExclamationRed';
import Jcb from './Jcb';
import MasterCard2 from './MasterCard2';
import Plus from './Plus';
import Visa from './Visa';
import XfinityAssistant from './XfinityAssistant';
import XfinityFlex from './XfinityFlex';

const table = {
  AmericanExpress,
  'american-express': AmericanExpress,
  'American Express': AmericanExpress,
  ApplePay,
  'apple-pay': ApplePay,
  ArrowLeft,
  'arrow-left': ArrowLeft,
  BankPayment,
  'bank-payment': BankPayment,
  Bill,
  bill: Bill,
  BillClock,
  'bill-clock': BillClock,
  BillOutline,
  'bill-outline': BillOutline,
  BoxClosed,
  'box-closed': BoxClosed,
  Calendar,
  calendar: Calendar,
  CalendarBill,
  'calendar-bill': CalendarBill,
  CardPayment,
  'card-payment': CardPayment,
  CaretLeft,
  'caret-left': CaretLeft,
  Cash,
  cash: Cash,
  Check,
  check: Check,
  ChinaUnionPay,
  chinaunionpay: ChinaUnionPay,
  'China Union Pay': ChinaUnionPay,
  CircleI,
  'circle-i': CircleI,
  Discover,
  discover: Discover,
  Dismiss,
  dismiss: Dismiss,
  DinersClub,
  dinersclub: DinersClub,
  'Diners Club': DinersClub,
  IconCircleExclamationRed,
  'icon-circle-exclamation-red': IconCircleExclamationRed,
  JCB: Jcb,
  Jcb,
  jcb: Jcb,
  MasterCard: MasterCard2,
  'master-card': MasterCard2,
  'master-card2': MasterCard2,
  Plus,
  plus: Plus,
  Visa,
  visa: Visa,
  XfinityAssistant,
  'xfinity-assistant': XfinityAssistant,
  XfinityFlex,
  'xfinity-flex': XfinityFlex,
};

const SvgIcon = ({ icon, ...props }) => {
  const IconComp = table[icon];
  if (!IconComp) return null;
  return <IconComp {...props} />;
};

export default SvgIcon;
